var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"video",attrs:{"src":"video/tomap.mp4","muted":"","preload":"auto","autoplay":"","id":"main-wel-bg-video"},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }